<script setup lang="ts">
import { computed } from 'vue';
import { LIcon } from "@vue-leaflet/vue-leaflet";
import MarkerIcon from './MarkerIcon.vue';
import AlertIcon from "@/components/marker/AlertIcon.vue";
import { marker_colors, GradientPoint } from '../../lib/marker_colors';

interface Props {
  color: string;
  enabled?: boolean;
  width?: number;
  height?: number;
  is_issue: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  enabled: true,
  width: 50,
  height: 45,
  is_issue: false
});

const colors = computed((): Array<GradientPoint> => marker_colors(props.color, props.enabled));
// const horizontal = computed(() => kinds.value.length > 1);

// const width = ref(50);
// const height = ref(45);
</script>

<template>
  <alert-icon v-if="props.is_issue" :colors="colors" :width="props.width" :height="props.height"/>
  <!--  <l-icon class-name="" :options="{ iconSize: [props.width, props.height], iconAnchor: [25, 43]}">-->
  <marker-icon v-else :width="props.width" :height="props.height" :colors="colors"/>
  <!--  </l-icon>-->
</template>

<style scoped lang="scss">
</style>

<!-- vim: softtabstop=2:shiftwidth=2
-->
